var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.593,
    height: 18.528
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon ionic-ios-arrow-back",
    d: "M7.4 9.266l-3.852 3.849-3.155 3.156a1.324 1.324 0 101.872 1.87l7.942-7.937a1.322 1.322 0 00.039-1.826L2.27.386a1.324 1.324 0 00-1.875 1.87z",
    fill: "currentColor"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMC41OTMiIGhlaWdodD0iMTguNTI4IiB2aWV3Qm94PSIwIDAgMTAuNTkzIDE4LjUyOCI+CiAgPHBhdGggaWQ9Ikljb25faW9uaWMtaW9zLWFycm93LWJhY2siIGRhdGEtbmFtZT0iSWNvbiBpb25pYy1pb3MtYXJyb3ctYmFjayIgZD0iTTMuMTkzLDkuMjYyLDcuMDQ1LDUuNDEzLDEwLjIsMi4yNTdBMS4zMjQsMS4zMjQsMCwxLDAsOC4zMjguMzg3TC4zODYsOC4zMjRBMS4zMjIsMS4zMjIsMCwwLDAsLjM0NywxMC4xNWw3Ljk3Niw3Ljk5MmExLjMyNCwxLjMyNCwwLDAsMCwxLjg3NS0xLjg3WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTAuNTkzIDE4LjUyOCkgcm90YXRlKDE4MCkiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";
export { SvgArrowLeft as ReactComponent };